import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import {
  ContextMenuComponent,
  MasterComponent,
  MasterDetailComponent,
  PanelComponent,
  PanelHeaderComponent,
  TitleComponent,
} from '@rocksoft/cdk';
import { User } from '@rocksoft/security-sdk';
import { UserListItemContainerComponent } from '../user-list-item/user-list-item.container';

@Component({
  selector: 'era-user-list-ui',
  templateUrl: './user-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MasterDetailComponent,
    MasterComponent,
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    UserListItemContainerComponent,
  ],
})
export class UserListComponent {
  public readonly users = input<User[]>();
  public readonly editEnabled = input<boolean>();
  public readonly addUserEvent = output();
  public readonly toggleEditEvent = output();

  addUser(): void {
    this.addUserEvent.emit();
  }

  toggleEdit() {
    this.toggleEditEvent.emit();
  }
}
